import React from 'react';
import emailjs from 'emailjs-com';
import './Contact.css'
import Fade from 'react-reveal/Fade';


const Contact = () => {

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_vxcrt4t', 'template_uu0zq5e', e.target, 'user_xIPcfJBJKtlEOuM0G16L3')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset()
    }

    return (
        <div className="container" id="contact">
            <div className="row mt-5">
                <h3 className=""><span style={{ borderBottom: '3px solid green' }}>Contact</span></h3>
                <div className="col-md-6 mt-5">
                    <Fade left>
                        <h5 className=""><span style={{ borderLeft: '3px solid green' }}><span className="ms-2">Get In Touch</span></span></h5>
                        <div className="mt-5">
                            <h4>Let's make something together.</h4>
                            <h4 className="mt-3">Feel free to send me an email if you're looking for a front end engineer, have a question or just want to say hi!</h4>
                        </div>
                        <div className="mt-5">
                            <div className="d-flex">
                                <div>
                                    <i className="fas fa-map-marker-alt fa-1x" style={{ color: '#198754' }}></i>
                                </div>
                                <div className="ms-3">
                                    <h5>Chattogram, Bangladesh</h5>
                                </div>
                            </div>
                            <div className="d-flex mt-2">
                                <div>
                                    <i class="far fa-envelope-open fa-1x" style={{ color: '#198754' }}></i>
                                </div>
                                <div className="ms-3">
                                    <h5>rajdevullash111@gmail.com</h5>
                                </div>
                            </div>
                            <div className="d-flex mt-2">
                                <div>
                                    <i className="fas fa-mobile-alt fa-1x" style={{ color: '#198754' }}></i>
                                </div>
                                <div className="ms-3">
                                    <h5>+88 01644836367</h5>
                                </div>
                            </div>
                        </div>
                        <div className="ms-md-5 ps-md-5 mt-5">
                            <a href="https://www.facebook.com/princeboy.rd.9"><i className="fab fa-facebook fa-2x m-2 ms-md-auto" style={{ color: '#198754' }}></i></a>
                            <a href="https://www.linkedin.com/in/raj-dev-ullash-831512203/"><i className="fab fa-linkedin fa-2x m-2" style={{ color: '#198754' }}></i></a>
                            <a href="https://github.com/Rajdev-ullash"><i className="fab fa-github fa-2x m-2" style={{ color: '#198754' }}></i></a>
                        </div>
                    </Fade>
                </div>
                <div className="col-md-6">
                    <Fade right>
                        <form onSubmit={sendEmail}>
                            <div className="row pt-5 mx-auto">
                                <div className="col-10 form-group mx-auto">
                                    <input type="text" className="form-control" placeholder="Name" name="name" />
                                </div>
                                <div className="col-10 form-group pt-2 mx-auto">
                                    <input type="email" className="form-control" placeholder="Email Address" name="email" />
                                </div>
                                <div className="col-10 form-group pt-2 mx-auto">
                                    <input type="text" className="form-control" placeholder="Subject" name="subject" />
                                </div>
                                <div className="col-10 form-group pt-2 mx-auto">
                                    <textarea className="form-control" id="" cols="30" rows="8" placeholder="Your message" name="message"></textarea>
                                </div>
                                <div className="col-10 mx-auto pt-3 justify-content-md-center align-content-md-center d-flex">
                                    <input type="submit" className="btn btn-info" value="Send Message"></input>
                                </div>
                            </div>
                        </form>
                    </Fade>
                </div>
            </div>
        </div>
    );
};

export default Contact;